import React, { useState, useEffect } from 'react';
import {
  IconButton,
  Tooltip,
  Badge
} from '@mui/material';
import {
  HelpOutline as HelpIcon
} from '@mui/icons-material';
import HelpCenter from './HelpCenter';

interface HelpButtonProps {
  showBadge?: boolean;
  badgeContent?: number;
}

/**
 * HelpButton - Main help button for navigation bar
 *
 * Usage:
 * <HelpButton showBadge />
 */
const HelpButton: React.FC<HelpButtonProps> = ({
  showBadge = false,
  badgeContent
}) => {
  const [open, setOpen] = useState(false);
  const [initialArticleId, setInitialArticleId] = useState<string | undefined>();
  const [initialCategory, setInitialCategory] = useState<string | undefined>();

  // Listen for custom events to open help with specific article
  useEffect(() => {
    const handleOpenHelp = (e: CustomEvent) => {
      const { articleId, category } = e.detail || {};
      setInitialArticleId(articleId);
      setInitialCategory(category);
      setOpen(true);
    };

    window.addEventListener('openHelp' as any, handleOpenHelp);

    return () => {
      window.removeEventListener('openHelp' as any, handleOpenHelp);
    };
  }, []);

  const handleClick = () => {
    setInitialArticleId(undefined);
    setInitialCategory(undefined);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Tooltip title="Help Center">
        <IconButton color="inherit" onClick={handleClick}>
          <Badge
            badgeContent={showBadge ? badgeContent : 0}
            color="error"
            invisible={!showBadge || !badgeContent}
          >
            <HelpIcon />
          </Badge>
        </IconButton>
      </Tooltip>

      <HelpCenter
        open={open}
        onClose={handleClose}
        initialArticleId={initialArticleId}
        initialCategory={initialCategory}
      />
    </>
  );
};

export default HelpButton;
